export default [
    {
        path: '/finance/accounts',
        name: 'accounts',
        props: true,
        component: () => import('@/views/finance/accounts/index.vue'),
        meta: {
            pageTitle: 'Accounts',
            breadcrumb: [
                {
                text: 'Accounts',
                active: true,
                },
            ],
        },
    },
    {
        path: '/finance/accounts/add',
        name: 'create-accounts',
        component: () => import('@/views/finance/accounts/create.vue'),
        meta: {
            pageTitle: 'Create Accounts',
            breadcrumb: [
                {
                text: 'Accounts',
                to: { name: 'accounts' },
                },
                {
                text: 'Create Accounts',
                active: true,
                },
            ],
        },
    },
    {
        path: '/finance/accounts/:id',
        name: 'detail-accounts',
        props: true,
        component: () => import('@/views/finance/accounts/detail.vue'),
        meta: {
            pageTitle: 'Detail Accounts',
            breadcrumb: [
                {
                text: 'Accounts',
                to: { name: 'accounts' },
                },
                {
                text: 'Detail Accounts',
                active: true,
                },
            ],
        },
    },
]